import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { ScanCvService } from '../scan-cv/services/scan-cv/scan-cv.service';

@Component({
  selector: 'app-scan-linkedin-result',
  templateUrl: './scan-linkedin-result.component.html',
  styleUrls: ['./scan-linkedin-result.component.css'],
})
export class ScanLinkedinResultComponent {
  @Input() scanResultData: any;
  cvScores: any = {};
  contentData: any;
  user: any;
  constructor(
    private content: FetchDataService,
    private translate: TranslateService,
    private scanCvService: ScanCvService,
    private router: Router
  ) {
    this.user = JSON.parse(localStorage.getItem('userInfo')!);
    const navigate = this.router.getCurrentNavigation();
    if (navigate?.extras.state) {
      const formData = new FormData();
      formData.append('cv', navigate?.extras.state!['data']);

      this.scanCvService.scanLinkedInProfile(formData).subscribe((data) => {
        this.scanResultData = data;
        this.cvScores.total = this.calculateScore(this.scanResultData);
        this.cvScores.headline = this.calculateScore(
          this.scanResultData.headline
        );
        this.cvScores.summary = this.calculateScore(
          this.scanResultData.summary
        );
        this.cvScores.experience = this.calculateScore(
          this.scanResultData.experience
        );
        this.cvScores.education = this.calculateScore(
          this.scanResultData.education
        );
        this.cvScores.technical = this.calculateScore(
          this.scanResultData.technical
        );
      });
    }
  }

  ngOnInit(): void {
    this.loadContent(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadContent(event.lang);
    });
  }

  loadContent(lang: string): void {
    this.content.getContentData(lang, 'scan-linkedin-result').subscribe({
      next: (data) => {
        this.contentData = data;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getCheckIcon(fieldName: string): string {
    const fieldValue = this.findFieldValue(this.scanResultData, fieldName);

    if (fieldValue === 0) {
      return 'assets/icon/wrong-check.png';
    } else if (fieldValue === 1) {
      return 'assets/icon/right check.png';
    } else {
      return 'assets/icon/wrong-check.png';
    }
  }

  private findFieldValue(data: any, fieldName: string): any {
    if (data === null || data === undefined) {
      return undefined;
    }

    if (typeof data === 'object') {
      for (const key in data) {
        if (key === fieldName) {
          return data[key];
        }
        const nestedValue = this.findFieldValue(data[key], fieldName);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }

    if (Array.isArray(data)) {
      for (const item of data) {
        const nestedValue = this.findFieldValue(item, fieldName);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }

    return undefined;
  }

  calculateScore(data: any): number {
    let total = 0;
    let count = 0;

    function traverseAndScore(section: any) {
      if (Array.isArray(section)) {
        section.forEach((item) => traverseAndScore(item as any));
      } else {
        Object.values(section).forEach((value) => {
          if (typeof value === 'number') {
            total += value;
            count++;
          } else {
            traverseAndScore(value as any);
          }
        });
      }
    }

    traverseAndScore(data);
    return parseFloat(((total / count) * 100).toFixed(1));
  }

  getTitleAndDescription(section: string, key: string): { title: string; description: string } {
    if (!this.contentData) return { title: '', description: '' };

    const sectionData = this.contentData[section];

    if (Array.isArray(sectionData)) {
      for (const entry of sectionData) {
        if (entry[key]) {
          return {
            title: entry[key].title,
            description: entry[key].description,
          };
        }
      }
    } else if (sectionData && sectionData[key]) {
      return {
        title: sectionData[key].title,
        description: sectionData[key].description,
      };
    }

    return { title: '', description: '' };
  }

  getKeys(obj: any): string[] {    
    return Object.keys(obj);
  }
}
